import { FormBuilder, FormGroup } from '@angular/forms';
import { Input } from '@angular/core/src/metadata/directives';
import { OnInit } from '@angular/core/';
import { ImportClientService } from 'app/admin/importclient/import-client.service';
import { MdDialogRef } from '@angular/material/dialog/dialog-ref';
import { MdDialog, MdDialogConfig } from '@angular/material';
import { Component, ViewContainerRef } from '@angular/core';

import {
    SaveInstructionComponent
} from 'app/admin/importclient/mappinginstructions/saveinstruction/save-instruction.component';

@Component({
    selector: 'mapping-instructions',
    templateUrl: './mapping-instructions.component.html'
})
export class MappingInstructionsComponent implements OnInit {
    dialogRef: MdDialogRef<any>;
    mappingInstructions = [];
    @Input() selectedMappingFilter: any;

    constructor(
        public viewContainerRef: ViewContainerRef,
        public dialog: MdDialog,
        private importClientService: ImportClientService,
        private formBuilder: FormBuilder) { }


    ngOnInit() {
        this.importClientService.currentMappingFilter.subscribe(values => {
            this.selectedMappingFilter = values;
            this.loadMappingInstruction();
        });
    }

    loadMappingInstruction() {
        this.importClientService.getMappingINSTRUCTIONS(this.selectedMappingFilter).subscribe(response => {
            this.mappingInstructions = response.arrResult.mappingInfoVO.mappingInstructions;
        });
    }

    openSaveInstruction(action: string) {
        let config = new MdDialogConfig();
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(SaveInstructionComponent, config);
        this.dialogRef.componentInstance.action = action;
        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/mappinginstructions/mapping-instructions.component.ts